import { showCustomDialog } from '@juvare/common-web-ui/DialogHelper';
import React from 'react';
import { DialogWizardContent } from './WizardDialogContent';
export const showWizardDialog = (props) => {
    showCustomDialog({
        maxWidth: props.maxWidth,
        content: (close) => (React.createElement(DialogWizardContent, Object.assign({}, props, { onCancel: () => {
                var _a;
                (_a = props.onCancel) === null || _a === void 0 ? void 0 : _a.call(props);
                close();
            }, onSubmitSuccess: (...params) => {
                var _a;
                (_a = props.onSubmitSuccess) === null || _a === void 0 ? void 0 : _a.call(props, ...params);
                close();
            } }))),
    });
};
